import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/checkMarkCircle.svg';

export const IconCheckMarkCircle = createIconComponent(Icon);
